import { motion } from "framer-motion";

export function Section({ id, children, className = "", testid }) {
  return (
    <section
      id={id}
      data-testid={testid}
      className={`py-24 sm:py-32 px-6 sm:px-12 lg:px-24 ${className}`}
    >
      <div className="max-w-7xl mx-auto">{children}</div>
    </section>
  );
}

export function Overline({ children, dark = false }) {
  return (
    <p
      className={`text-xs sm:text-sm uppercase tracking-[0.22em] font-bold ${
        dark ? "text-[#D8A48F]" : "text-[#2A4D3B]"
      }`}
    >
      {children}
    </p>
  );
}

export function FadeIn({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function PageHero({ overline, title, subtitle, image }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-32 sm:pt-40 pb-20 px-6 sm:px-12 lg:px-24 overflow-hidden bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[1.3fr_1fr] gap-12 lg:gap-20 items-end">
        <div>
          <Overline>{overline}</Overline>
          <h1 className="mt-5 font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#1A1A1A]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-7 max-w-xl text-base sm:text-lg leading-relaxed text-[#4A4540]">
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <FadeIn delay={0.15}>
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border-4 border-[#FDFBF7] shadow-[0_30px_60px_-30px_rgba(26,26,26,0.35)]">
              <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </FadeIn>
        )}
      </div>
    </section>
  );
}
